import { parseEnum } from "~/utils";
import { FactionType } from "./FactionType";

export enum AgentIcon {
  Emperor = "Emperor",
  SpacingGuild = "Guild",
  BeneGesserit = "BeneGesserit",
  Fremen = "Fremen",
  Landsraad = "Landsraad",
  City = "City",
  SpiceTrade = "SpiceTrade",
}

export const agentIconToFactionType = (
  agentIcon: AgentIcon
): FactionType | null => {
  return parseEnum(FactionType, agentIcon);
};

export const factionTypeToAgentIcon = (faction: FactionType): AgentIcon => {
  const agentIcon = parseEnum(AgentIcon, faction);
  if (!agentIcon) {
    throw new Error("unexpected: could not convert faction to agentIcon");
  }
  return agentIcon;
};
